import React, { ReactNode } from 'react';

import cx from 'classnames';

import styles from './Badge.module.scss';

interface IBadgeProps {
	variant: 'success' | 'warning' | 'error' | 'info' | 'disabled';
	children: ReactNode;
}

const Badge = (props: IBadgeProps) => {
	const { variant = 'info', children } = props;
	return <div className={cx(styles.badge, styles[variant])}>{children}</div>;
};

export default Badge;
